import { Style, Fill, Stroke } from 'ol/style';

const inoutflowStyle = {
	inCentralHub: new Style({
		// fill: new Fill({ color: 'rgba(255, 237, 135, 1)', opacity: '1' }),
		fill: new Fill({ color: '#84bd00', opacity: '1' }),
		stroke: new Stroke({
			// color: 'rgba(245, 208, 0, 1)',
			color: '#009f4d',
			width: 2.5,
			opacity: '1',
		}),
	}),
	outCentralHub: new Style({
		// fill: new Fill({ color: 'rgba(124, 215, 254, 1)', opacity: '1' }),
		fill: new Fill({ color: '#F9AF23', opacity: '1' }),
		stroke: new Stroke({
			color: '#FF7F08',
			width: 2.5,
			opacity: '1',
		}),
	}),
	inoutCentralHub: new Style({
		fill: new Fill({ color: 'rgba(255, 107, 119, 1)', opacity: '1' }),
		stroke: new Stroke({
			color: 'rgba(255, 10, 10, 1)',
			width: 2.5,
			opacity: '1',
		}),
	}),
	selectedFeature: new Style({
		fill: new Fill({ color: 'rgba(0, 0, 0, 0.6)', opacity: '1' }),
	}),
};

export {inoutflowStyle};